function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg169PitcairnIslands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ACABB1"
    },
    points: "409.043,201.739 384,210.087 358.957,201.739 350.609,180.87 358.957,160 409.043,160   400.696,180.87 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M325.565,201.739v91.825C325.565,338.294,384,352,384,352s58.435-13.706,58.435-58.436v-91.825  H325.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M330.832,315.319C345.196,342.895,384,352,384,352s38.804-9.105,53.168-36.681L384,226.783  L330.832,315.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M442.435,292.637L384,201.739l-58.435,90.899v0.927c0,8.279,2.006,15.491,5.267,21.754L384,232.613  l53.168,82.706c3.262-6.263,5.267-13.476,5.267-21.754V292.637z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "256,0 256,48.896 215.853,89.043 256,89.043 256,166.957 203.464,166.957 256,219.492   256,256 232.281,256 166.957,190.664 166.957,256 89.043,256 89.043,178.276 11.331,256 0,256 0,207.104 40.147,166.957 0,166.957   0,89.043 52.536,89.043 0,36.508 0,0 23.719,0 89.043,65.336 89.043,0 166.957,0 166.957,77.724 244.669,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152.001 104.001,152.001 104.001,256 152.001,256 152.001,152.001 256,152.001   256,104.001 152.001,104.001 152.001,0 104.001,0 104.001,104.001 0,104.001 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.959 0,230.821 0,256 0,256 89.041,166.959  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.138,89.041 256,25.179 256,0 256,0 166.959,89.041  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg169PitcairnIslands);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };